<template>
  <b-card tag="section"
          header-class="bg-lightgreen">
    <b-card-title class="h5">
      <b-icon icon="card-checklist"></b-icon>
      辨識項目
    </b-card-title>
    <b-list-group>
      <b-list-group-item>
        桶柑果蒂：
        <b-spinner v-if="isLoad"
                   variant="primary"
                   type="grow"
                   label="Spinning"
                   small></b-spinner>
        <template v-else>{{ pedicle | displayBoolean }}</template>
      </b-list-group-item>
      <b-list-group-item>
        桶柑疤痕數量：
        <b-spinner v-if="isLoad"
                   variant="primary"
                   type="grow"
                   label="Spinning"
                   small></b-spinner>
        <template v-else>{{ scar | displayNumber }} 個</template>
      </b-list-group-item>
      <b-list-group-item>
        桶柑疤痕面積比例：
        <b-spinner v-if="isLoad"
                   variant="primary"
                   type="grow"
                   label="Spinning"
                   small></b-spinner>
        <template v-else>{{ proportionOfScar | displayNumber }} ％</template>
      </b-list-group-item>
    </b-list-group>
  </b-card>
</template>

<script>
export default {
  name: 'ResultCard',
  components: {},
  filters: {
    displayNumber (item) {
      const regex = /[0-9]+/i
      return regex.test(item) ? item : '--'
    },
    displayBoolean (item) {
      if (item === undefined) return '--'
      return item ? '有' : '無'
    }
  },
  mixins: {},
  props: {
    fruit: {
      required: true
    },
    scar: {
      required: true
    },
    proportionOfScar: {
      required: true
    },
    pedicle: {
      required: true
    },
    isLoad: {
      type: Boolean,
      required: true
    }
  },
  data: function () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  methods: {}
}
</script>

<style lang="scss" scoped>
  .bg-lightgreen {
    background-color: #28a74520;
  }
</style>
